<!--Footer Starts-->
<footer>
  <div class="container-fluid">
    <p class="copyright text-center">
      {{companyName}} {{currentDate | date: 'yyyy'}}
    </p>
  </div>
</footer>
<!--Footer Ends-->